import cfg from 'cfg';

/**
 * Handler to add text programmatically at the caret position without losing the position of the input caret
 * @param {*} input ref to HTML input
 * @param {*} onChange callback which accepts value as 0nth argument
 */
export const addInputText = (input, onChange) => currentValue => text => {
    if (input) {
        const currentValString = typeof currentValue === 'string' ? currentValue : '';
        const nextSelectionStart = (currentValString.slice(0, input.selectionStart) + text).length;
        const value =
            currentValString.slice(0, input.selectionStart) +
            text +
            currentValString.slice(input.selectionStart, currentValString.length);
        onChange(value);
        // restore the caret not to be at the end of the line
        setTimeout(() => input.setSelectionRange(nextSelectionStart, nextSelectionStart), 0);
    }
};

const PROVIDERS = cfg.bookmakers.filter(e => e.id !== 'none');
const PROVIDERS_MAP = PROVIDERS.reduce((acc, el) => {
    acc[el.id] = el.name;
    return acc;
}, {});

export const getProviders = allowed =>
    Array.isArray(allowed)
        ? allowed.reduce((acc, el) => {
              const name = PROVIDERS_MAP[el];
              if (name) {
                  acc.push({ name, id: el });
              }
              return acc;
          }, [])
        : PROVIDERS;



/** WEBPACK FOOTER **
 ** ../src/dash/front/inputs/common.js
 **/